export default __webpack_public_path__ + "static/media/insurance-policy.d51d2b0a.svg";